import React from "react";
import { Bot, X } from "lucide-react";

interface ChatHeaderProps {
  onClose: () => void;
}

export const ChatHeader: React.FC<ChatHeaderProps> = ({ onClose }) => {
  return (
    <div
      className="px-4 py-3 sm:px-6 sm:py-4 border-b flex justify-between items-center"
      style={{
        borderColor: "var(--border-color)",
        backgroundColor: "var(--bg-secondary)",
      }}
    >
      <div className="flex items-center gap-2 sm:gap-3">
        <div
          className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl flex items-center justify-center shadow-lg"
          style={{ backgroundColor: "var(--primary-color)" }}
        >
          <Bot className="w-6 h-6 sm:w-7 sm:h-7 text-white" />
        </div>
        <div>
          <h2
            className="text-lg sm:text-xl font-bold"
            style={{ color: "var(--text-primary)" }}
          >
            Assistente SIGA
          </h2>
          <p className="text-sm" style={{ color: "var(--text-tertiary)" }}>
            Tutor Inteligente • Sempre Online
          </p>
        </div>
      </div>
      <button
        onClick={onClose}
        className="p-2 rounded-lg transition-colors hover:opacity-80"
        style={{ color: "var(--text-tertiary)" }}
        title="Fechar assistente"
        aria-label="Fechar assistente"
      >
        <X className="w-6 h-6" />
      </button>
    </div>
  );
};
